import { render, staticRenderFns } from "./PropertyModal.vue?vue&type=template&id=08313102&scoped=true&"
import script from "./PropertyModal.vue?vue&type=script&lang=js&"
export * from "./PropertyModal.vue?vue&type=script&lang=js&"
import style0 from "./PropertyModal.vue?vue&type=style&index=0&id=08313102&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08313102",
  null
  
)

export default component.exports